import logger from './logger';

// Extension IDs for Chrome and Edge
export const CHROME_EXTENSION_ID = 'lljjhhjbbppcbfbhmflgjhloagchmijo';
export const CHROME_EXTENSION_STORE_URL = 'https://chromewebstore.google.com/detail/hls-player-play-m3u8-dash/lljjhhjbbppcbfbhmflgjhloagchmijo';

export const EDGE_EXTENSION_ID = 'hpjofgdodgbgelploffffpacpdpbnljg';
export const EDGE_EXTENSION_STORE_URL = 'https://microsoftedge.microsoft.com/addons/detail/hls-player-play-m3u8-d/hpjofgdodgbgelploffffpacpdpbnljg';

/**
 * Detect if the current browser is Microsoft Edge
 */
export const isEdgeBrowser = (): boolean => {
  const isEdge = navigator.userAgent.indexOf("Edg") !== -1;
  logger.debug(`[Browser Detection] userAgent: ${navigator.userAgent}, isEdge: ${isEdge}`);
  return isEdge;
};

/**
 * Get the appropriate extension ID based on detected browser
 */
export const getExtensionId = (): string => {
  const extensionId = isEdgeBrowser() ? EDGE_EXTENSION_ID : CHROME_EXTENSION_ID;
  logger.debug(`[Extension Utils] Using extension ID: ${extensionId}`);
  return extensionId;
};

/**
 * Get the appropriate extension store URL based on detected browser
 */
export const getExtensionStoreUrl = (): string => {
  const storeUrl = isEdgeBrowser() ? EDGE_EXTENSION_STORE_URL : CHROME_EXTENSION_STORE_URL;
  logger.debug(`[Extension Utils] Using extension store URL: ${storeUrl}`);
  return storeUrl;
};

/**
 * Check if a URL uses HTTP protocol
 */
export const isHttpStream = (url: string): boolean => {
  try {
    const urlObj = new URL(url);
    return urlObj.protocol === 'http:';
  } catch {
    return false;
  }
};

/**
 * Generate the extension player URL for a given stream URL
 */
export const getExtensionPlayerUrl = (streamUrl: string): string => {
  const encodedUrl = encodeURIComponent(streamUrl);
  const extensionId = getExtensionId();
  return `chrome-extension://${extensionId}/player/player.html?url=${encodedUrl}`;
};

/**
 * Generate a browser-specific error message for extension installation
 */
export const getExtensionErrorMessage = (): string => {
  return "This HTTP stream requires the HLS Player extension to play properly.";
};

/**
 * Handle HTTP stream playback by opening in extension
 * Returns true if handled by extension, false if should be handled normally
 */
export const handleHttpStream = (url: string): boolean => {
  if (!isHttpStream(url)) return false;
  
  try {
    // Open in new tab
    window.open(getExtensionPlayerUrl(url), '_blank');
    return true;
  } catch (error) {
    logger.error('Error opening stream in extension:', error);
    // Return false so the app can handle the error
    return false;
  }
}; 